import React, { Fragment } from 'react';
import Navigation from "./Navigation";
import Header from "./Header";
import Footer from "./Footer";

const Layout =({children}) =>{
    return(
        <Fragment>
            <Header/>
            <Navigation />
            <main>{children}</main>
            <Footer />
        </Fragment>
    )
}

export default Layout;